// extracted by mini-css-extract-plugin
export default {"menuContainer":"FAQ_menuContainer__J6aSx","menuContent":"FAQ_menuContent__ULBvH","list":"FAQ_list__9bGVe"};